import { render, staticRenderFns } from "./Etapa10.vue?vue&type=template&id=dcada474&scoped=true"
import script from "./Etapa10.vue?vue&type=script&lang=js"
export * from "./Etapa10.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=dcada474&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa10.vue?vue&type=style&index=1&id=dcada474&prod&lang=css"
import style2 from "./Etapa10.vue?vue&type=style&index=2&id=dcada474&prod&lang=scss"
import style3 from "./Etapa10.vue?vue&type=style&index=3&id=dcada474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcada474",
  null
  
)

export default component.exports